var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_13544)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.46999L7.63 0.0299927C7.87 -0.0200073 8.12 -0.0200073 8.37 0.0299927L16 1.45999V10.74C16 13.67 14.49 16.4 12 17.96L8.53 20.13C8.21 20.33 7.79 20.33 7.47 20.13L4 17.96C1.51 16.41 0 13.68 0 10.75V1.46999Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87 12.22C6.62 12.22 6.38 12.11 6.2 11.93L4.28 10.01C3.91 9.64001 3.91 9.04001 4.28 8.67001C4.65 8.30001 5.25 8.30001 5.62 8.67001L6.87 9.92001L10.03 6.76001C10.4 6.39001 11.01 6.40001 11.37 6.78001C11.73 7.15001 11.73 7.74001 11.37 8.11001L7.54 11.94C7.36 12.12 7.12 12.23 6.87 12.23V12.22Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_13544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20.29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.e3820f9e1d251de46838ea463c89f18a.svg";
export { ForwardRef as ReactComponent };